/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Col_BuildInputs */

const en_admin_funnel_col_build = /** @type {(inputs: Admin_Funnel_Col_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

/**
* | output |
* | --- |
* | "Build" |
*
* @param {Admin_Funnel_Col_BuildInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_col_build = /** @type {((inputs?: Admin_Funnel_Col_BuildInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Col_BuildInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_col_build(inputs)
});
export { admin_funnel_col_build as "admin.funnel.col.build" }